module.exports = __webpack_public_path__ + "static/media/beach_marker_dark_blue.dee785ee.svg";